import { render, staticRenderFns } from "./LefSecondaryNavigation.vue?vue&type=template&id=2dda520e&scoped=true"
import script from "./LefSecondaryNavigation.vue?vue&type=script&lang=js"
export * from "./LefSecondaryNavigation.vue?vue&type=script&lang=js"
import style0 from "./LefSecondaryNavigation.vue?vue&type=style&index=0&id=2dda520e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda520e",
  null
  
)

export default component.exports